<!-- Declined the old way only with comments -->
<div *ngIf="declineReasons?.length == 1 && declineReasons[0] === 'no like'; else listDeclineReasons">
  <p class="h5-subheader mb-1">Comments:</p>
  <p>"{{declineComments}}"</p>
</div>

<ng-template #listDeclineReasons>
  <div *ngIf="declineReasons?.length > 0">
    <h5>Selected reasons</h5>
    <ul>
      <li *ngFor="let reason of declineReasons">
        <span *ngIf="reason !== 'no like'">{{reason}}</span>
      </li>
    </ul>
  </div>

  <div *ngIf="declineComments">
    <p class="h5-subheader mb-1">Comments:</p>
    <p>"{{declineComments}}"</p>
  </div>
</ng-template>